import script from "./orderAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./orderAdd.vue?vue&type=script&setup=true&lang=js"

import "./orderAdd.vue?vue&type=style&index=0&id=b90992bc&lang=less"

const __exports__ = script;

export default __exports__